interface PageNavItem {
  label: string;
  path: string;
}

export const PAGE_NAV_ITEMS: PageNavItem[] = [
  {
    label: "About",
    path: "/",
  },
  {
    label: "Our Journey",
    path: "/our-journey",
  },
  {
    label: "Team",
    path: "/team",
  },
  {
    label: "Portfolio",
    path: "/portfolio",
  },
  {
    label: "Career",
    path: "/career",
  },
];

export const CONTACT_SECTION_ID = "contact";
